"use client";
import { useState } from 'react';

export default function DeleteAccountCard({ user, onCancel, onDeleteAccount }) {
    const [showDeleteCard, setShowDeleteCard] = useState(false);
    const [emailConfirmation, setEmailConfirmation] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [showInitialModal, setShowInitialModal] = useState(false);
    const [showFinalModal, setShowFinalModal] = useState(false);

    const handleInitialDeleteClick = () => {
        setShowInitialModal(true);
    };

    const handleInitialConfirm = () => {
        setShowInitialModal(false);
        setShowDeleteCard(true);
    };

    const handleEmailConfirmation = () => {
        if (emailConfirmation !== user?.email) {
            alert('البريد الإلكتروني المدخل غير صحيح. يرجى إدخال البريد الإلكتروني الصحيح.');
            return;
        }
        setShowFinalModal(true);
    };

    const handleFinalConfirm = () => {
        setShowFinalModal(false);
        setIsDeleting(true);
        onDeleteAccount();
    };

    const handleCancel = () => {
        setShowDeleteCard(false);
        setEmailConfirmation('');
        onCancel();
    };

    const handleInitialCancel = () => {
        setShowInitialModal(false);
    };

    const handleFinalCancel = () => {
        setShowFinalModal(false);
    };

    return (
        <>
            {/* Initial Confirmation Modal */}
            <div className={`modal fade ${showInitialModal ? 'show' : ''}`} 
                 style={{ display: showInitialModal ? 'block' : 'none' }} 
                 tabIndex="-1" 
                 role="dialog"
                 aria-labelledby="initialModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-light">
                        <div className="modal-header border-0">
                            <h5 className="modal-title text-danger" id="initialModalLabel">
                                <i className="bi bi-exclamation-triangle"></i> تأكيد حذف الحساب
                            </h5>
                            <button type="button" className="btn-close" onClick={handleInitialCancel} aria-label="إغلاق"></button>
                        </div>
                        <div className="modal-body text-center">
                            <div className="mb-3">
                                <i className="bi bi-exclamation-triangle text-warning" style={{ fontSize: '3rem' }}></i>
                            </div>
                            <h6 className="mb-3">أنت تحاول حذف حسابك</h6>
                            <p className="text-muted">هل أنت متأكد من أنك تريد المتابعة؟</p>
                        </div>
                        <div className="modal-footer border-0 justify-content-center">
                            <button type="button" className="btn btn-outline-secondary" onClick={handleInitialConfirm}>
                                <i className="bi bi-check-circle"></i> تأكيد
                            </button>
                            <button type="button" className="btn btn-danger me-2" onClick={handleInitialCancel}>
                                <i className="bi bi-x-circle"></i> إلغاء
                            </button>
                            
                        </div>
                    </div>
                </div>
            </div>

            {/* Final Confirmation Modal */}
            <div className={`modal fade ${showFinalModal ? 'show' : ''}`} 
                 style={{ display: showFinalModal ? 'block' : 'none' }} 
                 tabIndex="-1" 
                 role="dialog"
                 aria-labelledby="finalModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <h5 className="modal-title text-danger" id="finalModalLabel">
                                <i className="bi bi-exclamation-triangle"></i> تأكيد نهائي
                            </h5>
                            <button type="button" className="btn-close" onClick={handleFinalCancel} aria-label="إغلاق"></button>
                        </div>
                        <div className="modal-body text-center">
                            <div className="mb-3">
                                <i className="bi bi-exclamation-triangle text-danger" style={{ fontSize: '3rem' }}></i>
                            </div>
                            <h6 className="mb-3">هل أنت متأكد تماماً من حذف حسابك؟</h6>
                            <p className="text-danger fw-bold">هذا الإجراء نهائي ولا يمكن التراجع عنه.</p>
                        </div>
                        <div className="modal-footer border-0 justify-content-center">
                            <button type="button" className="btn btn-outline-secondary me-2" onClick={handleFinalCancel}>
                                <i className="bi bi-x-circle"></i> إلغاء
                            </button>
                            <button type="button" className="btn btn-danger" onClick={handleFinalConfirm}>
                                <i className="bi bi-trash"></i> نعم، احذف الحساب
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Backdrop */}
            {(showInitialModal || showFinalModal) && <div className="modal-backdrop fade show"></div>}

            {/* Main Delete Account Card */}
            {!showDeleteCard ? (
                <div className="card rounded-4 shadow-sm p-4">
                    <div className="text-center">
                        <h4 className="text-danger mb-3">
                            <i className="bi bi-exclamation-triangle"></i> حذف الحساب
                        </h4>
                        <p className="text-muted mb-4">
                            إذا كنت تريد حذف حسابك نهائياً، اضغط على الزر أدناه.
                        </p>

                        <p className="alert alert-danger">هذا الإجراء نهائي ولا يمكن التراجع عنه.</p>
                        <button 
                            className="btn btn-outline-secondary"
                            onClick={handleInitialDeleteClick}
                        >
                            <i className="bi bi-trash"></i> حذف الحساب
                        </button>
                        <a href="/account" 
                            className="btn btn-danger ms-2"
                        >
                            <i className="bi bi-x-circle"></i> إلغاء 
                        </a>
                    </div>
                </div>
            ) : (
                <div className="card rounded-4 shadow-sm p-4 border-danger">
                    <div className="text-center mb-4">
                        <h4 className="text-danger mb-3">
                            <i className="bi bi-exclamation-triangle"></i> تأكيد حذف الحساب
                        </h4>
                    </div>

                    <div className="alert alert-danger" role="alert">
                        <h6 className="alert-heading">
                            <i className="bi bi-exclamation-triangle"></i> تحذير مهم!
                        </h6>
                        <p className="mb-2">
                            <strong>هذا الإجراء نهائي ولا يمكن التراجع عنه.</strong>
                        </p>
                        <hr />
                        <p className="mb-0">
                            عند حذف حسابك سيتم:
                        </p>
                        <ul className="mb-0 mt-2">
                            <li>حذف جميع بياناتك الشخصية نهائياً</li>
                            <li>حذف جميع الروابط المختصرة التي أنشأتها</li>
                            <li>حذف جميع المشاركات والمحتوى المرتبط بحسابك</li>
                            <li>عدم إمكانية استرداد أي من هذه البيانات</li>
                        </ul>
                    </div>

                    <div className="mb-4">
                        <label htmlFor="emailConfirmation" className="form-label">
                            <strong>لتأكيد حذف الحساب، يرجى كتابة بريدك الإلكتروني:</strong>
                        </label>
                        <input
                            type="email"
                            className="form-control"
                            id="emailConfirmation"
                            value={emailConfirmation}
                            onChange={(e) => setEmailConfirmation(e.target.value)}
                            placeholder="أدخل بريدك الإلكتروني هنا"
                            disabled={isDeleting}
                        />
                        <div className="form-text text-muted">
                            البريد الإلكتروني المرتبط بحسابك: <strong>{user?.email}</strong>
                        </div>
                    </div>

                    <div className="d-flex gap-2 justify-content-center">
                    <button 
                            className="btn btn-outline-secondary"
                            onClick={handleEmailConfirmation}
                            disabled={isDeleting || !emailConfirmation}
                        >
                            {isDeleting ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    جاري الحذف...
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-trash"></i> نعم، احذف الحساب
                                </>
                            )}
                        </button>

                       <button 
                            className="btn btn-danger"
                            onClick={handleCancel}
                            disabled={isDeleting}
                        >
                            <i className="bi bi-x-circle"></i> إلغاء
                        </button>
                      
                    </div>
                </div>
            )}
        </>
    );
}
